export default {
      id: "save-green-usage",
      viewBox: "0 0 20 19",
      url: "/" + "sprite.svg#save-green",
      toString: function () {
        return this.url;
      }
    }